module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-backplates-remnants.0068c483.png";